import { lazy } from "react";

export const GalleryAsync = lazy(() => import("./Gallery"));
